import {
  getSubscribersList,
  getSubscribersPaginated,
  getLocationSubscribersPaginated,
  getLocationGroupSubscribersPaginated,
  addSubscriberList,
  updateSubscriberList,
  getSubscribers,
  uploadSubscribers,
  getSubcriberProfile,
  getLocationGuestsPaginated,
  getLocationGroupGuestsPaginated,
  getGuestProfile,
  getS3Subscribers,
  getDeletedCustomers
} from "@/api/subscribers";
import papa from "papaparse";

function downloadCsv(url = ''){
  console.log('---URL downloading: ', url)
  return new Promise((resolve, reject) => {
    papa.parse(url, {
      download: true,
      dynamicTyping: true,
      header: true,
      complete: function(results) {
        resolve(results)
      }
    });
  })
  
}

export default {
  async getSubscribersList({ commit }) {
    const response = await getSubscribersList();
    commit("setSubscribersList", response);
  },
  async addSubscriberList({ state, dispatch }) {
    // console.log(JSON.parse(JSON.stringify(state.formData)));
    let payload = JSON.parse(JSON.stringify(state.formData));
    await addSubscriberList(payload);
    setTimeout(() => {
      dispatch("getSubscribersList");
    }, 3000);
  },
  async updateSubscriberList({ state, dispatch }) {
    let payload = JSON.parse(JSON.stringify(state.formData));
    let id = state.subscribersListItem.id;
    await updateSubscriberList(id, payload);
    setTimeout(() => {
      dispatch("getSubscribersList");
    }, 3000);
  },
  async getSubscribers({ commit }) {
    const response = await getSubscribers();
    commit("setSubscribers", response);
  },
  async getSubscribersPaginated({ commit, state }) {
    const response = await getSubscribersPaginated(state.subscriberPage);
    commit("setSubscribers", response);
  },
  async getLocationSubscribersPaginated({ commit, state }) {
    const response = await getLocationSubscribersPaginated(
      state.subscriberPage,
      state.locationIds
    );
    commit("setSubscribers", response);
  },
  async getLocationGroupSubscribersPaginated({ commit, state }) {
    const response = await getLocationGroupSubscribersPaginated(
      state.subscriberPage,
      state.locationGroupIds
    );
    commit("setSubscribers", response);
  },    
  uploadCsvSubscribers({ state, dispatch }) {
    // console.log(state.formData);
    uploadSubscribers(state.formData);
    setTimeout(() => {
      dispatch("getSubscribers");
    }, 3000);
  },
  async getSubcriberGuestProfile({ commit, state }) {
    let id = state.profileId;
    let guest = localStorage.getItem("guest");
    let response;
    if (guest == "guest") {
      response = await getGuestProfile(id);
    }
    if (guest == "subscriber") {
      response = await getSubcriberProfile(id);
    }

    commit("setSubscriberProfile", response);
  },
  async getLocationGuestsPaginated({ commit, state }) {
    const response = await getLocationGuestsPaginated(
      state.guestPage,
      state.locationIds
    );
    // console.log("response", response);
    commit("setGuests", response);
  },
  async getLocationGroupGuestsPaginated({ commit, state }) {
    const response = await getLocationGroupGuestsPaginated(
      state.guestPage,
      state.locationGroupIds
    );
    // console.log("response", response);
    commit("setGuests", response);
  },

  async getSubscriberS3({ commit, state }) {
    try {
      console.log('---papaparse')
      const response = await getS3Subscribers(
        state.locationIds,
        true,
        state.subscriberPageS3['pageFile']
      );
      state.subscriberPageS3['totalRowsCount'] = (response['count'] != null && response['count'] != 0) ? response['count'] : 8200 // final_file_count,
      state.subscriberPageS3['fileEndCount']  = (response['max_count'] != null && response['max_count'] != 0 ) ? response['max_count'] : 456 //final_max_count,
      let result = await Promise.all(response['urls'].map(data => downloadCsv(data)))
      result = result.map(res => res.data).flat()
      result = result.filter(o => Object.keys(o).length > 1  )
      let pos_id = result[0]['pos_id']
      let customer_type = "subscribers"      
      let deletedGuests = await getDeletedCustomers(customer_type,pos_id)      
      try {
        let myArrayFiltered = [];
        myArrayFiltered = result.filter(el => {
            return !deletedGuests.find(element => {
              return element.email === el.email;
            });
        });        
        return myArrayFiltered        
      } catch (error) {
        console.log("error in Final result:",error)
      }
      console.log('----- reuslt: ',result)
      return result
    } catch (error) {
      console.log('---error3: ', result)
    }
  },

  async getGuestS3({ commit, state }) {

   try {
    console.log('---papaparse')
    const response = await getS3Subscribers(
      state.locationIds,
      false,
      state.guestPageS3['pageFile']
    );
    state.guestPageS3['totalRowsCount'] = response['count'] != null ? response['count'] : 9200 // final_file_count,
    state.guestPageS3['fileEndCount']  = response['max_count'] != null ? response['max_count'] : 656 //final_max_count,
    let result = await Promise.all(response['urls'].map(data => downloadCsv(data)))
    result = result.map(res => res.data).flat()
    result = result.filter(o => Object.keys(o).length > 1  )
    let pos_id = result[0]['pos_id']
    let customer_type = "guests"      
    let deletedGuests = await getDeletedCustomers(customer_type,pos_id)    
    try {
      let myArrayFiltered = [];
      myArrayFiltered = result.filter(el => {
          return !deletedGuests.find(element => {
            return ((String((element.customer_name)) === String((el.customer_name)))&&(String((element.last_four_digits)) === String((el.last_four_digits))));
          });
      });        
      return myArrayFiltered        
    } catch (error) {
      console.log("error in Final result:",error)
    }
    console.log('----- reuslt: ',result)
    return result
   } catch (error) {
     console.log('----error2: ', error)
   }
    // commit("setSubscribers", result);
  },
};
